import { Type } from "class-transformer";
import BankAccount from "./bankAccount";

export default class RefundApprovedResponse {
  refundId: string;
  licensePlate: string;
  countryCode: string;
  variableSymbol: string;
  @Type(() => BankAccount)
  bankAccount: BankAccount;
  refundReason: string;
  amount: number;
}
